var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaadinArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.9223L15 4.57227V9.07227H12C0 9.07227 0 21.0723 0 21.0723C0 21.0723 1.5 15.0723 11.7 15.0723H15V19.4223L24 11.9223Z",
    fill: "#222F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaadinArrowForward);
export default __webpack_public_path__ + "static/media/vaadin_arrow-forward.9d3800a3422c1854a0bf3ce10723d8c9.svg";
export { ForwardRef as ReactComponent };